import React from "react";
import '../../styles/Coding.css';
import WasteSensorSchematic from "../../media/coding/waste_sensor.png"
import PlotThePlot from "../../media/coding/plot_the_plot.png"
import AdHunterPoster from "../../media/coding/ad_hunter_poster.png"
import Robotics from "../../media/coding/robotics.png"
import QualiaCookbook from "../../media/coding/qualia_cookbook.png"

const stanfordLink = "http://news.stanford.edu/2019/07/11/students-develop-technology-measures-dumpster-usage/";
const robotLink = "https://www.youtube.com/watch?v=C7MjA_qvWVY&ab_channel=bb1of3"

function CodingSection() {
  return (
    <div className="codePage">
      <div className="section-title">Coding</div>

      <div className="project-item">
        <h2 id="qualiacookbook">Qualia Cookbook</h2>
        <img className="code-img" src={QualiaCookbook} alt="Qualia Cookbook screenshot"/>
        <p>
          Recently, I built a website that I'm pretty proud of. It's called 
          <a href="https://mbbbackus.github.io/qualiaCookbook/#/"> the qualia cookbook</a>. My goal is to
          post my writing about qualia on my own website instead of on a conventional blog because I want to be able to
          customize the reading experience. I want to be able to add images, videos, and interactive elements,
          and in particular, I've added a nested reading experience such that you can click on a link and it will
          expand the article within the page so that you can easily keep track of what you're reading.
        </p>
        <p>
          It's a work in progress, but I'm especially proud of the main articles that I've written as well as the 
          unique user interface.
        </p>
      </div>

      <div className="project-item">
        <h2 id="plottheplot">Plot the Plot</h2>
        <img className="code-img" src={PlotThePlot} alt="Plot the Plot visualization"/>
        <p>
          After college, I built a website called Plot the Plot
          that visualizes how the quality of a tv show changes over time. Below is
          a visualization generated by the website for Game of Thrones, which is particularly
          interesting because of how far the ratings dropped during the last season. 
        </p>
        <p>
          I learned a lot about web scraping and data visualization while building this website. Ultimately,
          I had to shut it down because it was too expensive. IMDB doesn't supply a normal API. Just zip
          files that get updated every sunday. I was paying $50 a month for a server that would download and
          organize the data. Furthermore, I wanted data about which actors were in which episodes, but
          IMDB didn't make that available. It was a fun project though! My friends were mad when I ended it
          because they loved using it.
        </p>
      </div>

      <div className="project-item">
        <h2 id="wastesensor">Stanford Waste Sensor</h2>
        <img className="code-img" src={WasteSensorSchematic} alt="Waste sensor schematic"/>
        <p>
          I spent my Junior and Senior year at Stanford developing a cheap
          sensor that could measure the capacity of the dumpsters on campus and
          send this data to a live web portal. <a href={stanfordLink}>Here's an article about my work</a>.
          And below you can see a simple schematic of the prototype.
        </p>
      </div>

      <div className="project-item">
        <h2 id="adhunter">Ad Hunter</h2>
        <img className="code-img" src={AdHunterPoster} alt="Ad Hunter poster"/>
        <p>
          For one of my classes at Stanford, some friends and I developed a classifier
          that would classify instagram posts as either ads or not. The motivation was 
          derived from the recent FCC laws that require all sponsored/influencer content on
          social media websites to be clearly marked as advertisements.
          The code is all <a href="https://github.com/mbbbackus/InstagramPosts">on Github</a>.
        </p>
      </div>

      <div className="project-item">
        <h2 id="vexrobotics">Vex Robotics</h2>
        <img className="code-img" src={Robotics} alt="Vex Robotics robot"/>
        <p>
          I did <a href="https://www.vexrobotics.com/">Vex Robotics</a> in high school. I led the construction 
          and programming of the robot. My teams have won a dozen tournaments, an innovate award, and 
          qualified for states, nationals, and worlds.
        </p>
        <p>
          <a href={robotLink}>Here's a video discussing the work that went into the robot.</a>
        </p>
      </div>
    </div>
  );
}

export default CodingSection;
